import {
  Text,
  Button,
  GreyGrey60,
  IndigoIndigo60,
  Link,
  Primary12Regular,
  TextInputField,
  Flex
} from '@sequencehq/core-components'

const WEBHOOK_SECRET_DOCS_URL =
  'https://docs.sequencehq.com/reference/webhook-events'

export const WebhookSecretDetails = ({
  webhookSecret
}: {
  webhookSecret?: string
}) => {
  return (
    <Flex flexDirection="column" gap="8px">
      <Flex gap="8px" alignItems="flex-end">
        <TextInputField
          label="Secret key"
          readOnly
          id="webhook-secret"
          value={webhookSecret}
          styles={{ wrapper: { flex: 1 } }}
        />
        <Button
          variant="secondary"
          onClick={() => {
            navigator.clipboard.writeText(webhookSecret ?? '').catch(() => {
              console.error('Failed to copy to clipboard')
            })
          }}
        >
          Copy
        </Button>
      </Flex>
      <Text {...Primary12Regular} color={GreyGrey60}>
        Copy and store this key now. Use it to verify the authenticity of
        incoming webhook requests.{' '}
        <Link
          _hover={{ textDecoration: 'none' }}
          to={WEBHOOK_SECRET_DOCS_URL}
          color={IndigoIndigo60}
          target="_blank"
        >
          Learn more
        </Link>
        .
      </Text>
    </Flex>
  )
}
